var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SystemMaintenance.SetFieldValueSynchronization"),
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            gap: "10px"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: !_vm.gridIsEdit, type: "primary" },
                  on: { click: _vm.onNew }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_New")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: !_vm.gridIsEdit, type: "danger" },
                  on: { click: _vm.onDelete }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
              ),
              _c("el-checkbox", {
                staticStyle: { margin: "0 5px" },
                on: { change: _vm.onUseHqSet },
                model: {
                  value: _vm.valueSyncManage.useHqSet,
                  callback: function($$v) {
                    _vm.$set(_vm.valueSyncManage, "useHqSet", $$v)
                  },
                  expression: "valueSyncManage.useHqSet"
                }
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GeneralSettings")))
              ])
            ],
            1
          ),
          _c("cargo-ag-grid", {
            staticStyle: { "min-height": "400px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.valueSyncList
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }